import { useTranslation } from "react-i18next";
import { PaymentTaxCollectorSelectModal } from "@features/PaymentTaxCollectorSelectModal/PaymentTaxCollectorSelectModal";
import { IconButton } from "@components/IconButton/IconButton";
import { Pencil16Icon } from "@components/icons";
import { Skeleton } from "@components/Skeleton/Skeleton";
import { useModalActions } from "@store/modal/modal";
import { type ITaxCollectorType } from "@services/payments/types";

interface ISelectedTaxCollectorDisplayProps {
  currentPaymentTaxCollector: ITaxCollectorType | undefined;
  isPaymentSectionLodaing?: boolean;
}

export const SelectedTaxCollectorDisplay: React.FC<
  ISelectedTaxCollectorDisplayProps
> = (props) => {
  const { currentPaymentTaxCollector, isPaymentSectionLodaing } = props;
  const { create } = useModalActions();
  const { t } = useTranslation();

  const openPaymentTaxCollectorSelectModal = () => {
    create((modalProps) => <PaymentTaxCollectorSelectModal {...modalProps} />);
  };

  if (!currentPaymentTaxCollector) {
    return <Skeleton variant="text" className="w-64" />;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-grey-dark">
        {`${t("billsPayment.paymentTaxCollector")}: `}
        <span className="font-semibold text-base-black">
          {currentPaymentTaxCollector.name}
        </span>
      </span>
      <IconButton
        onClick={openPaymentTaxCollectorSelectModal}
        icon={Pencil16Icon}
        disabled={isPaymentSectionLodaing}
        aria-label={t("billsPayment.paymentTaxCollector")}
      />
    </div>
  );
};
